/**
 * Utilitários para criação de slugs amigáveis e URLs personalizadas baseadas nos títulos dos artigos.
 */

export const slugify = (text: string): string => {
  if (!text) return '';
  return text
    .toString()
    .normalize('NFD') // Decompõe caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos e diacríticos
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // Remove caracteres especiais não alfanuméricos
    .replace(/[\s_]+/g, '-') // Converte espaços e underscores para hífens
    .replace(/-+/g, '-') // Remove hífens duplicados
    .replace(/^-+|-+$/g, ''); // Remove hífens no início e fim
};

export const getArticleSlug = (article: { id?: string | number; title?: string; slug?: string } | null | undefined): string => {
  if (!article) return '';
  if (article.slug && typeof article.slug === 'string' && article.slug.trim()) {
    return article.slug.trim();
  }
  if (article.title && typeof article.title === 'string' && article.title.trim()) {
    const generated = slugify(article.title);
    if (generated) return generated;
  }
  return article.id ? String(article.id) : '';
};

export const getArticleUrl = (article: { id?: string | number; title?: string; slug?: string } | null | undefined): string => {
  const slug = getArticleSlug(article);
  return slug ? `/artigo/${slug}` : '/artigos';
};
